module.exports = __webpack_public_path__ + "fonts/WixMadeforDisplay-ExtraBold.ad641b63.ttf";